import React from "react";

export function ChalkLogoIcon({ vectorEffect, ...rest }: React.ComponentProps<"svg">) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      {...rest}
    >
      <path
        d="M2 0.75H30C30.6904 0.75 31.25 1.30964 31.25 2V30C31.25 30.6904 30.6904 31.25 30 31.25H2C1.30964 31.25 0.75 30.6904 0.75 30V2C0.75 1.30964 1.30964 0.75 2 0.75Z"
        fill="#70CD96"
        vectorEffect={vectorEffect}
      />
      <path
        d="M2 0.75H30C30.6904 0.75 31.25 1.30964 31.25 2V30C31.25 30.6904 30.6904 31.25 30 31.25H2C1.30964 31.25 0.75 30.6904 0.75 30V2C0.75 1.30964 1.30964 0.75 2 0.75Z"
        stroke="#33514A"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        vectorEffect={vectorEffect}
      />
      <path
        d="M5.6674 28.7478C4.0407 28.7478 3 27.3971 3 25.8699C3 24.3427 4.00687 22.9921 5.62341 22.9921C6.91854 22.9921 7.89226 23.7006 8.1027 25.0065H6.88538C6.75276 24.298 6.29872 23.8887 5.64574 23.8887C4.74917 23.8887 4.27347 24.7189 4.27347 25.8699C4.27347 27.0209 4.78232 27.8512 5.70123 27.8512C6.34338 27.8512 6.80825 27.4195 6.93004 26.711H8.15886C7.94842 28.017 6.96388 28.7478 5.66875 28.7478H5.6674ZM9.24287 28.6368V21H10.4162V24.1877H10.4385C10.6706 23.413 11.2465 22.9921 12.0544 22.9921C13.2717 22.9921 13.8699 23.8224 13.8699 25.0397V28.6368H12.6634V25.3936C12.6634 24.3644 12.298 23.8995 11.5564 23.8995C10.8148 23.8995 10.4494 24.4083 10.4494 25.3164V28.6368H9.24287ZM16.9135 28.7478C15.7625 28.7478 14.9546 28.0285 14.9546 27.0209C14.9546 25.8808 15.9506 25.4605 17.1794 25.3272L18.5855 25.1831V25.0173C18.5855 24.2757 18.1646 23.888 17.4677 23.888C16.7707 23.888 16.3945 24.2311 16.3607 24.8509H15.1542C15.1982 23.777 16.0616 22.9914 17.4893 22.9914C18.9171 22.9914 19.7913 23.7439 19.7913 25.2386V28.6368H18.6288V27.5521H18.5957C18.3636 28.3161 17.7431 28.7478 16.9135 28.7478ZM17.2234 27.8512C18.0868 27.8512 18.5848 27.2645 18.5848 26.213V26.0249L17.3784 26.1575C16.6476 26.2346 16.2274 26.5006 16.2274 27.0318C16.2274 27.5629 16.6922 27.8505 17.2234 27.8505V27.8512ZM21.2198 21H22.4262V28.6368H21.2198V21ZM25.1153 25.7481V28.6368H23.9088V21H25.1153V25.3834L27.395 23.1031H28.889L26.4652 25.5384L29 28.6375H27.4836L25.1153 25.7488V25.7481Z"
        fill="#224A41"
        stroke="#224A41"
        strokeWidth="0.3"
        strokeLinejoin="round"
        vectorEffect={vectorEffect}
      />
    </svg>
  );
}
